import { useTranslate } from "react-polyglot"

// Shown when a company user opens a route for a feature disabled for their
// company (ASA-225). The backend also returns 403 on the API; this gives a
// clean message instead of a broken/empty screen.
const NoFeatureAccess = () => {
    const t = useTranslate()

    return (
        <div className="m-noFeatureAccess">
            <p className="m-noFeatureAccess__message">
                {t("general.noFeatureAccess")}
            </p>
        </div>
    )
}

export default NoFeatureAccess
